let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

var BlsAnimations = (function () {
  const boundElements = new WeakSet();

  return {
    innit: function (root = document) {
      this.animates(root);
    },
    animates: function (root = document) {
      var animates = root.querySelectorAll(".scroll-trigger");
      if (animates.length > 0) {
        animates.forEach((i) => {
          if (boundElements.has(i) || i.hasAttribute("animation-end")) return;
          boundElements.add(i);
          const onAnimationEnd = (e) => {
            if (e.target !== i) return;
            i.removeEventListener("animationend", onAnimationEnd);
            setTimeout(() => {
              i.setAttribute("animation-end", "");
            }, 1000);
          };
          i.addEventListener("animationend", onAnimationEnd);
        });
      }
    },
  };
})();

let parser = new DOMParser();

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  cartError: "cart-error",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
};

class SwatchInit extends HTMLElement {
  connectedCallback() {
    this.init();
  }
  checkSwatches(e) {
    const { color, image, customValue, swatchType, optionSwatchValue } = e.dataset;
    if (!color) return;
    if (optionSwatchValue) {
      e.style.setProperty("--swatch--background", optionSwatchValue);
      return;
    }

    const useImageFirst = swatchType === "variant_images" && image;
    if (!useImageFirst && customValue) {
      e.classList.add(customValue.trim().replace(/\s+/g, "-"));
    }
    if (!useImageFirst && this.checkColor(color)) {
      e.style.backgroundColor = color;
      return;
    }
    if (image) {
      e.classList.add("color__" + color.trim().replace(/\s+/g, "-"));
      e.style.backgroundColor = null;
      e.style.backgroundImage = "url('" + image + "')";
      e.style.backgroundSize = "cover";
      e.style.backgroundRepeat = "no-repeat";
    }
  }
  checkColor(strColor) {
    var s = new Option().style;
    s.color = strColor;
    return s.color == strColor;
  }
}

function showToast(message, duration = 3000, customClass = "") {
  let toastContainer = document.getElementById("toast-container");
  if (!toastContainer) {
    toastContainer = document.createElement("div");
    toastContainer.id = "toast-container";
    document.body.appendChild(toastContainer);
  }

  const toast = document.createElement("div");
  toast.className = `toast show ${customClass}`;
  toast.innerHTML = message;
  toastContainer.appendChild(toast);

  setTimeout(() => {
    closeToast(toast);
  }, duration);
}

function closeToast(toast) {
  toast.classList.remove("show");
  setTimeout(() => {
    toast.remove();
    if (!document.querySelector("#toast-container .toast")) {
      document.getElementById("toast-container").remove();
    }
  }, 500);
}

// Storefront interactions share one event owner. Google tag is already loaded by GTM;
// only queue event commands here, never a second GA4 config or GTM event tag.
(function initStorefrontAnalytics() {
  if (customElements.get("theme-pairing-observer")) return;

  const observers = new Set();
  const viewedCards = new Set();
  let privacyLoading = false;

  function isDebug() {
    return new URLSearchParams(window.location.search).get("analytics_debug") === "1";
  }

  function contextAllowed() {
    if (window.Shopify?.designMode) return false;
    if (isDebug()) return true;
    const host = document.body?.dataset.analyticsHost;
    return Boolean(host && window.Shopify?.theme?.role === "main"
      && host.replace(/^www\./, "") === window.location.hostname.replace(/^www\./, "")
      && !new URLSearchParams(window.location.search).has("preview_theme_id"));
  }

  function analyticsAllowed() {
    try {
      return contextAllowed()
        && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
    } catch (_) {
      return false;
    }
  }

  function refreshObservers() {
    observers.forEach((observer) => observer.refresh());
  }

  function loadPrivacy() {
    if (!contextAllowed() || window.Shopify?.customerPrivacy || privacyLoading
      || typeof window.Shopify?.loadFeatures !== "function") return;
    privacyLoading = true;
    try {
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.2" }], () => {
        privacyLoading = false;
        refreshObservers();
      });
    } catch (_) {
      privacyLoading = false;
    }
  }

  function cleanText(value) {
    return String(value || "").replace(/\s+/g, " ").trim().slice(0, 100);
  }

  function destination(control) {
    const href = control?.getAttribute("href");
    if (!href || href.startsWith("#")) return "";
    try {
      const url = new URL(href, document.baseURI);
      if (!["http:", "https:"].includes(url.protocol)) return "";
      // Only public paths; strip query/fragment values and credentials.
      return cleanText(url.origin === window.location.origin ? url.pathname : url.host + url.pathname);
    } catch (_) {
      return "";
    }
  }

  function parameters(item, control, action) {
    const scope = item.closest("[data-analytics-scope]");
    const data = item.dataset;
    let position = Number(data.analyticsPosition) || 1;
    const topLevelItem = item.closest(".site-header__nav-item, .mobile-nav__menu-item");
    if (scope.dataset.analyticsScope === "header" && topLevelItem) {
      position = Array.from(topLevelItem.parentElement.children).indexOf(topLevelItem) + 1;
    }
    return {
      section_key: scope.dataset.analyticsScope,
      item_key: cleanText(data.analyticsItem),
      item_label: cleanText(data.analyticsLabel),
      destination_path: action === "navigate" || action === "view" ? destination(control) : "",
      action,
      position,
      click_target: action === "view" ? "card" : cleanText(control.dataset.analyticsTarget || "text"),
      ui_variant: scope.dataset.analyticsUi
        || `${window.matchMedia("(min-width: 1024px)").matches ? "desktop" : "mobile"}_${scope.dataset.analyticsLayout || "grid"}`,
      menu_path: cleanText(data.analyticsMenuPath),
      menu_level: Number(data.analyticsLevel) || 0,
      theme_id: String(window.Shopify?.theme?.id || ""),
    };
  }

  function emit(name, payload) {
    if (!analyticsAllowed()) return false;
    if (isDebug()) {
      // Explicit preview debugging is local only, including on the live domain.
      window.themeAnalyticsDebug = window.themeAnalyticsDebug || [];
      window.themeAnalyticsDebug.push({ event: name, ...payload });
      if (window.themeAnalyticsDebug.length > 50) window.themeAnalyticsDebug.shift();
      return true;
    }
    const measurementId = document.body?.dataset.analyticsDestination || "";
    if (!/^G-[A-Z0-9]+$/.test(measurementId)) return false;
    try {
      window.dataLayer = window.dataLayer || [];
      (function queueGoogleTagCommand() { window.dataLayer.push(arguments); })(
        "event", name, { ...payload, send_to: measurementId }
      );
      return true;
    } catch (_) {
      // Analytics must never interrupt native navigation or menu controls.
      return false;
    }
  }

  // Public component API: fixed event/field allowlists, the same consent gate and
  // local-only analytics_debug channel as Header/Pairing. Never pass form values.
  const contentEvents = new Set([
    "home_content_click", "sale_content_click", "product_content_click",
    "recommendation_click", "recommendation_drawer_click", "product_help_click",
    "product_help_drawer_click", "cart_print_click", "cart_share_click",
    "cart_product_click", "cart_error", "home_scroll_depth", "sale_scroll_depth", "product_scroll_depth",
  ]);
  function track(name, values = {}) {
    if (!contentEvents.has(name)) return false;
    loadPrivacy();
    if (!analyticsAllowed()) return false;
    const payload = { theme_id: String(window.Shopify?.theme?.id || ""),
      ui_variant: window.matchMedia("(min-width: 1024px)").matches ? "desktop" : "mobile" };
    for (const key of ["section_key", "item_key", "item_label", "action", "click_target", "source_product", "item_list_id"]) {
      if (values[key]) payload[key] = cleanText(values[key]);
    }
    for (const key of ["position", "percent_scrolled"]) {
      if (Number.isFinite(values[key])) payload[key] = values[key];
    }
    if (values.destination_path) payload.destination_path = destination({ getAttribute: () => values.destination_path });
    return emit(name, payload);
  }
  window.themeAnalytics = Object.freeze({ track });

  function pageKind() {
    if (document.body.classList.contains("index")) return "home";
    if (document.body.classList.contains("product")) return "product";
    if (/\/pages\/freshine-sale\/?$/.test(location.pathname)) return "sale";
    return "";
  }

  function contentContext(root) {
    return { section_key: root.dataset.contentSection,
      source_product: pageKind() === "product" ? location.pathname.split("/").filter(Boolean).pop() : "" };
  }

  function trackContentClick(event) {
    if (!analyticsAllowed()) return;
    const kind = pageKind();
    const target = event.target;
    // Card colors and +N Colors are intentionally excluded, including previews.
    if (target.closest?.(".product-item__swatches, .po-helptext-content, [data-analytics-click]")) return;
    const control = target.closest?.("a[href], button, summary, [role='button'], [role='tab']");
    if (!control || control.matches(":disabled, [aria-disabled='true']")
      || (event.type === "auxclick" && !control.matches("a[href]"))) return;

    const cart = control.closest(".cart-page");
    if (cart) {
      let name;
      if (control.matches('[data-cart-action="print"]')) name = "cart_print_click";
      else if (control.closest(".cart-page__share-app") && !control.closest('[role="dialog"]')) name = "cart_share_click";
      else if (control.matches("a.cart-page__media, a.cart-page__item-title")) name = "cart_product_click";
      if (name) track(name, { section_key: "cart", item_key: control.closest("[data-content-item]")?.dataset.contentItem || name,
        action: name === "cart_product_click" ? "navigate" : "click", destination_path: control.getAttribute("href"),
        click_target: control.matches(".cart-page__media") ? "image" : "text" });
      return;
    }
    if (!kind) return;
    const root = control.closest("[data-content-section]");
    if (!root) return;
    // Main product only opts in theme-owned information/media controls. Third-party
    // form fields, cart buttons and default option changes stay with their owner.
    if (root.dataset.contentSection === "product_main" && !control.closest("media-gallery")
      && !control.matches("[data-sale-popup-trigger], [data-product-option-action], [data-measurement-action]")) return;
    if (control.closest(".shopify-app-block, .jdgm-widget, form")) return;
    const drawerEvent = root.dataset.contentEvent;
    const row = control.closest(".product-recommendations__row");
    const card = control.closest("[data-product-card]") || row?.querySelector("[data-product-card]");
    const item = control.closest("[data-content-item], [data-service-card], .swiper-slide, .mc-accordion__item");
    const positioned = row || (control.matches('.swiper-pagination-bullet') ? control : item);
    const position = positioned?.parentElement ? Array.from(positioned.parentElement.children).indexOf(positioned) + 1 : 1;
    const label = control.getAttribute("aria-label") || control.textContent;
    let action = "click";
    let clickTarget = control.matches('.product-recommendations__link') ? 'preview' : control.querySelector("img, picture") ? "image" : "text";
    if (control.matches("[data-preview-close], #option-help-drawer-close")) { action = "close"; clickTarget = "close"; }
    else if (control.matches("[data-preview-choose]")) { action = "navigate"; clickTarget = "customize"; }
    else if (control.matches(".swiper-pagination-bullet, .swiper-button-next, .swiper-button-prev, .mg__thumb")) {
      action = "media_select"; clickTarget = control.matches(".swiper-button-next") ? "next" : control.matches(".swiper-button-prev") ? "previous" : "pagination";
    } else if (control.matches(".media-gallery__image")) { action = "zoom"; clickTarget = "image"; }
    else if (control.hasAttribute("aria-expanded") || control.matches("summary")) {
      action = control.getAttribute("aria-expanded") === "true" || control.parentElement?.open ? "collapse" : "expand";
    } else if (control.matches("[role='tab']")) { action = "tab_select"; clickTarget = "tab"; }
    else if (control.matches("[data-instagram-shop-trigger]")) action = "open";
    else if (control.matches("a[href]")) {
      if (!destination(control) && !control.getAttribute("href").startsWith("#")) return;
      action = "navigate";
    }
    // Recommendation entries open previews only in the inline list. Modified or
    // middle clicks retain native navigation. No open-success/lifecycle event.
    const recommendations = root.matches("product-recommendations") || root.dataset.contentSection === "you_may_also_like";
    if (recommendations && card) {
      if (!control.matches(".product-item__name, .product-item__media--ratio, [data-recommendation-preview-trigger]")) return;
      action = control.closest(".product-recommendations__row") && event.type !== "auxclick"
        && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey ? "open_preview" : "navigate";
    }
    const blockKey = control.closest('[data-content-item]')?.dataset.contentItem || item?.dataset.serviceCard;
    const itemKey = card?.dataset.contentItem || control.dataset.tabTarget || control.dataset.productTabsTab
      || control.dataset.contentItem || blockKey || (control.dataset.mediaId ? `media:${control.dataset.mediaId.split('-').pop()}` : '') || destination(control)
      || `${action}:${clickTarget}:${position}`;
    track(drawerEvent || (recommendations && card ? "recommendation_click" : `${kind}_content_click`), {
      ...contentContext(root), item_key: root.dataset.contentProduct || itemKey,
      item_label: card?.querySelector('.product-item__name')?.textContent || label, action, click_target: clickTarget,
      position, destination_path: control.getAttribute("href"),
      item_list_id: control.closest("[data-tab-panel]")?.dataset.tabPanel || root.dataset.contentList,
    });
  }

  // Only three depth milestones per requested page, sampled after user scroll.
  // No element observers, startup layout reads, animation-frame loop or DOM scan.
  const depths = new Set();
  let depthTimer;
  function trackDepth() {
    if (depthTimer || !pageKind() || !analyticsAllowed()) return;
    depthTimer = setTimeout(() => {
      depthTimer = null;
      const page = document.scrollingElement;
      if (!page || window.scrollY <= 0 || document.visibilityState !== "visible") return;
      const depth = Math.min(100, (window.scrollY + window.innerHeight) / page.scrollHeight * 100);
      for (const percent of [25, 50, 75]) {
        if (depth >= percent && !depths.has(percent)
          && track(`${pageKind()}_scroll_depth`, { section_key: pageKind(), percent_scrolled: percent })) depths.add(percent);
      }
      if (depths.size === 3) window.removeEventListener("scroll", trackDepth);
    }, 250);
  }
  window.addEventListener("scroll", trackDepth, { passive: true });
  window.addEventListener("pagehide", () => { clearTimeout(depthTimer); depthTimer = null; });

  function trackClick(event) {
    if (event.type === "auxclick" ? event.button !== 1 : event.button !== 0) return;
    try { trackContentClick(event); } catch (_) { /* Analytics cannot break a storefront interaction. */ }
    const control = event.target.closest?.("[data-analytics-click]");
    const item = control?.closest("[data-analytics-item]");
    const scope = item?.closest("[data-analytics-scope]");
    if (!scope || control.matches(":disabled, [aria-disabled='true']")) return;
    const name = control.dataset.analyticsClick;
    if (!["header_menu_click", "pairing_click"].includes(name)) return;
    loadPrivacy();
    let action = "navigate";
    if (control.dataset.analyticsAction === "toggle") {
      if (event.type === "auxclick") return;
      action = control.getAttribute("aria-expanded") === "true" ? "collapse" : "expand";
    } else if (!destination(control)) {
      return;
    }
    emit(name, parameters(item, control, action));
  }

  // Capture handles toggles that stop bubbling; click also covers keyboard
  // activation. auxclick adds middle-click without counting touch twice.
  document.addEventListener("click", trackClick, true);
  document.addEventListener("auxclick", trackClick, true);
  document.addEventListener("visitorConsentCollected", refreshObservers);
  document.addEventListener("visibilitychange", refreshObservers);
  window.addEventListener("pagehide", () => observers.forEach((observer) => observer.stop()));
  window.addEventListener("pageshow", refreshObservers);

  // One hidden lifecycle element per explicitly enabled homepage section.
  // Its owner supplies data-analytics-item/id/label/position on real cards.
  class ThemePairingObserver extends HTMLElement {
    connectedCallback() {
      this.timers = new Map();
      this.visible = new Set();
      observers.add(this);
      queueMicrotask(() => {
        if (!this.isConnected) return;
        loadPrivacy();
        this.refresh();
      });
    }

    disconnectedCallback() {
      this.stop();
      observers.delete(this);
    }

    stop() {
      this.observer?.disconnect();
      this.observer = null;
      this.timers?.forEach(clearTimeout);
      this.timers?.clear();
      this.visible?.clear();
    }

    refresh() {
      this.stop();
      if (!this.isConnected || document.visibilityState !== "visible" || !analyticsAllowed()
        || typeof IntersectionObserver !== "function") return;
      const scope = this.closest('[data-analytics-scope="pick_your_pairing"]');
      if (!scope) return;
      const observer = new IntersectionObserver((entries) => {
        // disconnect() does not invalidate callbacks already queued for delivery.
        if (this.observer !== observer || !this.isConnected) return;
        entries.forEach((entry) => {
          const card = entry.target;
          if (!entry.isIntersecting || entry.intersectionRatio < 0.5) {
            this.visible.delete(card);
            clearTimeout(this.timers.get(card));
            this.timers.delete(card);
            return;
          }
          this.visible.add(card);
          const key = `${scope.dataset.analyticsInstance}:${card.dataset.analyticsId}`;
          if (viewedCards.has(key) || this.timers.has(card)) return;
          this.timers.set(card, setTimeout(() => {
            this.timers.delete(card);
            if (this.observer !== observer || !this.isConnected || !card.isConnected || !this.visible.has(card)
              || document.visibilityState !== "visible" || viewedCards.has(key)) return;
            const link = card.querySelector('[data-analytics-click="pairing_click"][href]');
            if (link && destination(link) && emit("pairing_view", parameters(card, link, "view"))) {
              viewedCards.add(key);
              observer.unobserve(card);
            }
          }, 1000));
        });
      }, { threshold: [0, 0.5] });
      this.observer = observer;
      scope.querySelectorAll("[data-analytics-item][data-analytics-id]").forEach((card) => {
        const key = `${scope.dataset.analyticsInstance}:${card.dataset.analyticsId}`;
        if (!viewedCards.has(key)) this.observer.observe(card);
      });
    }
  }

  customElements.define("theme-pairing-observer", ThemePairingObserver);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", loadPrivacy, { once: true });
  } else {
    loadPrivacy();
  }
})();
